import { CoursesProgress } from './CoursesProgress/CoursesProgress'
import { InvalidJobTitleForRecommendedQuery, NoJobTitleFound } from './Errors'
import { useGetCourses } from './hooks/useGetCourses'
import { CoursesSkeleton } from './Skeleton'
import RecomendedCourses from './RecomendedCourses'
import { Container } from './styles'

const FutureLearn = () => {
  const { data, isLoading, error } = useGetCourses()
  const noJobTitleAvailable = !data?.jobTitle

  const getComponent = () => {
    if (error) return null
    if (isLoading) return <CoursesSkeleton />
    if (data?.progression.in_progress.length) return <CoursesProgress data={data.progression} />
    if (noJobTitleAvailable) return <NoJobTitleFound />
    if (!data.recommended?.length)
      return <InvalidJobTitleForRecommendedQuery jobTitle={data.jobTitle || 'Invalid Job Title'} />

    return <RecomendedCourses data={data?.recommended} saved={data?.progression.saved ?? []} />
  }

  return (
    <Container id="learning-content-dashboard" data-testid="learning-content-dashboard">
      {getComponent()}
    </Container>
  )
}

export * from './Shared'
export default FutureLearn
